export enum SignalInvoke {
  JoinTutorGroup = "JoinTutorGroup",
  LeaveTutorGroup = "LeaveTutorGroup",
  JoinLessonDashboardGroup = "JoinLessonDashboardGroup",
  /**
   * @remarks You need to send the flow session id
   */
  JoinAiTutorResponseGroup = "JoinAiTutorResponseGroup",
  /**
   * @remarks You need to send the flow session id
   */
  LeaveAiTutorResponseGroup = "LeaveAiTutorResponseGroup",
}

export type SigRJoinTutorGroup = (tutorId: string) => void;
export type SigRLeaveTutorGroup = (tutorId: string) => void;

export enum SignalOn {
  /**
   * @remarks Data received type: FlowGeneratorSession
   */
  DispatchFlowGeneratorSession = "DispatchFlowGeneratorSession",
  /**
   * @remarks Data received type: DispatchSocratesSessionStatus
   */
  DispatchSocratesSessionStatus = "DispatchSocratesSessionStatus",
  /**
   * @remarks Data received type: TODO
   */
  TutorAssigned = "TutorAssigned",

  /**
   * @remarks Data received type: TODO
   */
  InterventionUpdated = "interventionUpdated",

  /**
   * @remarks You need to append the flow sessionId to the end of this enum string
   */
  DispatchGPTText = "DispatchGPTText:",

  /**
   * @remarks You need to append the flow sessionId to the end of this enum string
   */
  DispatchGPTTextLoading = "DispatchGPTTextLoading:",

  /**
   * @remarks You need to append the flow sessionId to the end of this enum string
   */
  DispatchGPTFlowItem = "DispatchGPTFlowItem:",

  /**
   *  @remarks You need to append the flow sessionId to the end of this enum string
   */
  DispatchFlowItem = "dispatchflowitem:",

  /**
   *  @remarks You need to append the flow sessionId to the end of this enum string
   */
  DispatchGPTError = "dispatchgpterror:",

  /**
   *  @remarks Must be a part of the ai-tutor:flow-session-id to see updates
   */
  AiTutorResponseupdate = "aitutorresponseupdated",

  /**
   *  @remarks Must be a part of the ai-tutor:flow-session-id to see updates
   */
  AiTutorChatAlert = "aitutorchatalert",
}

export interface DispatchSocratesSessionStatus {
  flowGeneratorSessionId: number;
  socratesSessionId: string;
  status: SocratesSessionStatus | string;
  timestamp: string;
}

export enum SocratesSessionStatus {
  Initializing = "Initializing",
  Processing = "Processing",
  Active = "Active",
  Failed = "Failed",
}

export interface DispatchGPTTextLoading {
  isLoading: boolean;
  flowGeneratorSessionId: number;
  flowGeneratorSessionInterventionId: number;
  socratesSessionId: string;
}

export interface HeldReplyStatus {
  flowGeneratorSessionId?: number;
  message?: string;
  metadata?: string;
  flowGeneratorSessionInterventionMessageId?: number;
  dateCreated?: string;
  socratesSessionId?: string;
  heldStudentMessage?: HeldStudentMessage;
}

export interface HeldStudentMessage {
  flowGeneratorSessionInterventionMessageId: number;
  message?: string;
  metadata?: string;
  dateCreated: string;
}
